import { render, staticRenderFns } from "./RouletteWheel.vue?vue&type=template&id=0e917c5e&scoped=true&"
import script from "./RouletteWheel.vue?vue&type=script&lang=js&"
export * from "./RouletteWheel.vue?vue&type=script&lang=js&"
import style0 from "./RouletteWheel.vue?vue&type=style&index=0&id=0e917c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e917c5e",
  null
  
)

export default component.exports